import {
  SYSTEM_MAINTENANCE_NOTICE_REQUEST,
  SYSTEM_MAINTENANCE_NOTICE_RESPONSE,
} from '../actions/systemMaintenance.actions';

export default function systemMaintenanceNotice(state = {}, action) {
  switch (action.type) {
    case SYSTEM_MAINTENANCE_NOTICE_REQUEST: {
      return {fetching: true};
    }
    case SYSTEM_MAINTENANCE_NOTICE_RESPONSE: {
      let nextState = {...action.systemMaintenanceNotice};
      return nextState;
    }
  }
  return state;
}
